module.exports = __webpack_public_path__ + "static/media/sportAvatar__madden.14011050.jpg";